import { inject, Injectable } from '@angular/core';
import { IUser, UUID } from '@okcargo-apps/shared-domain';
import {
  CreateContactAndUserFromAppCommand,
  CreateContactAndUserFromAppCommandHandler,
  SoftDeleteContactAndUserFromAppCommand,
  SoftDeleteContactAndUserFromAppCommandHandler,
  UpdateContactAndUserFromAppCommand,
  UpdateContactAndUserFromAppCommandHandler,
} from '@okcargo/command-processor';
import { BaseCommandRepository } from '../command-repository/command.repository';
import { transformFromIUserToCreateCommand, transformFromIUserToUpdateCommand } from './user.mapper';

@Injectable({
  providedIn: 'root',
})
export class UserCommandService {
  private readonly createContactAndUserFromAppCommandHandler: CreateContactAndUserFromAppCommandHandler;
  private readonly updateContactAndUserFromAppCommandHandler: UpdateContactAndUserFromAppCommandHandler;
  private readonly softDeleteContactAndUserFromAppCommandHandler: SoftDeleteContactAndUserFromAppCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.createContactAndUserFromAppCommandHandler = new CreateContactAndUserFromAppCommandHandler(commandRepository);
    this.updateContactAndUserFromAppCommandHandler = new UpdateContactAndUserFromAppCommandHandler(commandRepository);
    this.softDeleteContactAndUserFromAppCommandHandler = new SoftDeleteContactAndUserFromAppCommandHandler(
      commandRepository,
    );
  }

  public createUser(user: IUser): Promise<void> {
    const command: CreateContactAndUserFromAppCommand = transformFromIUserToCreateCommand(user);
    return this.createContactAndUserFromAppCommandHandler.handle(command);
  }

  public updateUser(user: IUser): Promise<void> {
    const command: UpdateContactAndUserFromAppCommand = transformFromIUserToUpdateCommand(user);
    return this.updateContactAndUserFromAppCommandHandler.handle(command);
  }

  public softDeleteUser(id: UUID): Promise<void> {
    const command: SoftDeleteContactAndUserFromAppCommand = { id };
    return this.softDeleteContactAndUserFromAppCommandHandler.handle(command);
  }
}
